// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhg_sq","PhotoTitleEditForm__cancelBtn":"iy_b bhg_su bhg_st"};